import api from "../api/axiosInstance";

const unclaimedPackageService = {
    // Customer-facing — only packages possibleCustomer-tagged to the logged-in
    // customer (see unclaimedPackageController.getMyUnclaimedPackages).
    getMine: () => api.get("/unclaimed-packages/mine"),
    getAll: (params) => api.get("/unclaimed-packages", { params }),
    create: (payload) => api.post("/unclaimed-packages", payload),
    bulkCreate: (payload) => api.post("/unclaimed-packages/bulk", payload),
    update: (id, payload) => api.patch(`/unclaimed-packages/${id}`, payload),
    remove: (id) => api.delete(`/unclaimed-packages/${id}`),
    sendReminder: (id) => api.post(`/unclaimed-packages/${id}/send-reminder`),
    getGroupedByCustomer: () => api.get("/unclaimed-packages/grouped-by-customer"),
    sendBulkReminder: (customerId) => api.post("/unclaimed-packages/send-bulk-reminder", { customerId }),
    presignPhoto: (id, name, type) => api.post(`/unclaimed-packages/${id}/photo/presign`, { name, type }),
    finalizePhoto: (id, key) => api.post(`/unclaimed-packages/${id}/photo/finalize`, { key }),
    getPhotoUrl: (id) => api.get(`/unclaimed-packages/${id}/photo/url`),
};

export default unclaimedPackageService;
